module.exports = __webpack_public_path__ + "img/header_logo.43b8d4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/header_logo.png
// module id = 9C+W
// module chunks = 1 3